import AddIcon from '@mui/icons-material/Add';
import { Button } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AddTemplateModal from '../../common/AddTemplateModal';
import InputSearch from '../../common/InputSearch';
import { TemplatesTable } from '../../common/TemplatesTable/TemplatesTable';
import useModal from '../../shared/hooks/useModal/useModal';
import styles from '../UnitTemplates/UnitTemplates.module.scss';
import { getPalletTemplatesRequest, postCreatePalletTemplatesRequest } from './services/actions';
import { palletTemplateSelector } from './services/selector';
import { Spinner } from '../../common/Spinner/Spinner';
import ErrorResponse from '../../shared/ErrorResponse';
import { useNavigate } from 'react-router-dom';
import { getCountryListRequest } from '../../../entities/Countries/actions';

export const PalletTemplates = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { isShow, openModal, closeModal } = useModal();

  useEffect(() => {
    dispatch(getPalletTemplatesRequest({ level: 3 }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onAddHandler = () => {
    dispatch(getCountryListRequest());
    dispatch(postCreatePalletTemplatesRequest());
    openModal();
  };

  const { palletTemplates, createdPalletTemplates, loading, getPalletTemplatesError } =
    useSelector(palletTemplateSelector);

  const [tableData, setTableData] = useState<any[]>(palletTemplates);

  useEffect(() => {
    setTableData(palletTemplates);
  }, [palletTemplates]);

  useEffect(() => {
    if (Object.keys(getPalletTemplatesError).length !== 0 && getPalletTemplatesError?.status === 403) {
      navigate('/error');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getPalletTemplatesError]);

  return (
    <div className={styles.wrapper}>
      {Object.keys(getPalletTemplatesError).length !== 0 ? <ErrorResponse error={getPalletTemplatesError} /> : null}
      <section className={styles.templateHeader}>
        <div className={styles.loadingGroup}>
          <span className={styles.templateSubTitle}>Шаблони палет (Level 3)</span>
          {loading ? <Spinner /> : null}
        </div>
        <span>Створюйте і редагуйте шаблони етикеток для паллет</span>
      </section>
      <section className={styles.header}>
        <div className={styles.searchSection}>
          <div className={styles.searchGroup}>
            <span>Фільтр по всім полям:</span>
            <InputSearch setTableData={setTableData} data={palletTemplates} />
          </div>
          <Button variant="contained" type="button" className={styles.btn} onClick={onAddHandler}>
            <span className={styles.btnText}>Додати</span>
            <AddIcon className={styles.icon} />
          </Button>
        </div>
      </section>
      <section>
        <TemplatesTable data={tableData} level={3} />
      </section>
      <AddTemplateModal isShown={isShow} closeModal={closeModal} level={3} data={createdPalletTemplates} />
    </div>
  );
};
